import {getTooltip} from 'Components/tooltip/tooltip.tpl';
import '../../components/Ipid/_ipid.css';

export const templateIpidList = (templateList, templateListDom) => (templateList ? templateListDom : '');

const getProductName = (productName, tooltipMessage, tooltipDirection) => `
<div class="priips__item">
    <div class="priips__triangle">
            <div class="priips__triangle__up priips__sorted" data-sorted="produit_up" data-disabled="priips_disabled"></div>
            <div class="priips__triangle__down priips__sorted" data-sorted="produit_down"></div>
        </div>
    <div class="priips__header__title">${productName}</div>
    <div class="priips__table__tooltip">${tooltipMessage ? getTooltip(tooltipMessage, tooltipDirection) : ''}</div>
</div>
`;

const getDocumentName = (documentName, tooltipMessage1, tooltipDirection1) => `
<div class="priips__item">
    <div class="priips__triangle">
            <div class="priips__triangle__up priips__sorted" data-sorted="nom_up" data-disabled="priips_disabled"></div>
            <div class="priips__triangle__down priips__sorted" data-sorted="nom_down"></div>
        </div>
    <div class="priips__header__title">${documentName}</div>
    <div class="priips__table__tooltip">${tooltipMessage1 ? getTooltip(tooltipMessage1, tooltipDirection1) : ''}</div>
</div>
`;

const getAction = (action, tooltipMessage2, tooltipDirection2) => `
<div class="ipid__item">
    <div class="ipid__header__title">${action}</div>
    <div class="priips__table__tooltip">${tooltipMessage2 ? getTooltip(tooltipMessage2, tooltipDirection2) : ''}</div>
</div>
`;

export default class IpidTemplate {
    constructor() {
        this.getLoaderDOM = this.getLoaderDOM.bind(this);
        this.getHeaderDOM = this.getHeaderDOM.bind(this);
        this.getRenderTab = this.getRenderTab.bind(this);
        this.getTableItemDOM = this.getTableItemDOM.bind(this);
    }

    // eslint-disable-next-line class-methods-use-this
    getLoaderDOM({
        displayedProduct
    } = {}) {
        return `<div class="priips__loader__container">
      <div class="priips__loader">
        <span class="priips__loader__message">
            Chargements des documents pour le produit '${displayedProduct}'
        </span>
        <i class="priips__loader__spinner"></i>
      </div>
    </div>`;
    }

    // eslint-disable-next-line class-methods-use-this
    getHeaderDOM({
        displayedProduct,
        documentsListLength
    } = {}) {
        return `<div class="priips__table_header">
                <h2 class="priips__table_header__title">
                  Produit ${displayedProduct} : <span>${documentsListLength || '0'} document(s) trouvé(s)
                </h2>
          </div>`;
    }

    getFailedFetchTableDOM({
        displayedProduct
    } = {}) {
        const message = '<i>Le chargement des documents a échoué</i>';

        return `<div class="priips__table_overlay">
      <div class="priips__table_overlay__blurred_content">
        ${this.getHeaderDOM({displayedProduct})}
      </div>
      <div class="priips__table_overlay__clear_content">
        ${message}
      </div>
    </div>`;
    }

    getTableDOM({
        documentsListItems,
        displayedProduct,
        documentsListLength,
        documentListHeaderItem
    } = {}) {
        return `<table class="priips__table">
            <caption class="priips__table_header priips__table_header__title priips__header__caption priips__header__message">
               <div class="priips__item__download__message">
                <div>Produit ${displayedProduct} : <span>${documentsListLength || '0'} document(s) trouvé(s)</span></div>
               </div>
            </caption>
              <thead>
                <tr>
                  ${this.getRenderTab(documentListHeaderItem)}
                </tr>
              </thead>
              <tbody>
                ${documentsListItems || ''}
              </tbody>
            </table>`;
    }

    // eslint-disable-next-line class-methods-use-this
    getRenderTab(objectHeaderItemDom) {
        const {
            productName,
            documentName,
            action,
            tooltipMessage, tooltipDirection,
            tooltipMessage1, tooltipDirection1,
            tooltipMessage2, tooltipDirection2
        } = objectHeaderItemDom;
        return `
                   <th class="priips__table__support priipsth__blue" scope="col">
                  ${getProductName(productName, tooltipMessage, tooltipDirection)}</th>
                  <th class="priips__table__code-isin priipsth__blue" scope="col">
                  ${getDocumentName(documentName, tooltipMessage1, tooltipDirection1)}</th>
                  <th class="priips__table__prospectus priipsth__blue" scope="col">
                  ${getAction(action, tooltipMessage2, tooltipDirection2)}
                  </th>
                  `;
    }

    // eslint-disable-next-line class-methods-use-this
    getTableItemDOM({
        singleDocument: {
            document_name: name,
            document_produit: product,
            download_link: actionAttrsLink
        } = {}
    } = {}) {
        const actionAttrs = `href="${actionAttrsLink}" target="_blank"`;
        const actionDom = `<div title="télécharger" class="priips__link__center">
      <a class="priips__link priips__tooltip-container priips__table__actions__tooltip_container"
        ${actionAttrs}>
        <i class="axa-icons axa-icons-download priips__icon-download_blue"></i>
      </a>
      </div>`;
        return `<tr>
      <th class="priips__table__support" scope="row">
        <span>${product}</span>
      </th>
      <td class="priips__table__code-isin">
        <span>${name}</span>
      </td>
      <td class="priips__table__rapports__annuels"">
         ${actionAttrsLink ? actionDom : ''}
      </td>
      </tr>`;
    }
}
